import React from "react";
import { Spin } from "antd";
import { IErrorWarning } from "../../../store/types/misc";

type ITextInput = {
  label: string;
  name: string;
  value: string;
  type: "text" | "email" | "file" | "date" | "password" | string;
  status?: IErrorWarning;
  placeholder: string;
  loading?: boolean;
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  required?: boolean;
};

const TextInput: React.FC<ITextInput> = ({
  label,
  name,
  value,
  type,
  status,
  placeholder,
  loading,
  icon,
  rightIcon,
  onChange,
  onBlur,
  required = false,
}) => {
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={name}
          className="text-md tracking-wider mb-2 font-semibold"
        >
          {label}
        </label>
      )}
      <div
        className={`flex items-center w-full px-3 py-2 rounded-lg border transition-all duration-200 ${
          status
            ? "!border-red-500 ring-red-500"
            : "border-gray-300 ring-primary-500 focus-within:ring focus-within:ring-offset-2"
        }`}
      >
        {icon && <div className="mr-3 text-gray-500">{icon}</div>}{" "}
        <input
          id={name}
          name={name}
          value={value}
          type={type}
          placeholder={placeholder}
          onChange={onChange}
          className="w-full border-none outline-none placeholder-gray-400 text-base"
          onBlur={onBlur}
          required={required}
        />
        {loading && <Spin size="small" className="ml-3" />}
        {rightIcon && <div className=" text-gray-500">{rightIcon}</div>}
      </div>
    </div>
  );
};

export default TextInput;
